export default __webpack_public_path__ + "ba3a83adcb94357fc42f762985e4d3df.woff";